/*! Copyright (c) Safe As Milk. All rights reserved. */
class RecentSearches extends HTMLElement {
    constructor() {
        super();
        this.update();
    }
    update() {
        const ul = this.querySelector("ul");
        const parent = this.parentElement;
        const inHeaderPanel = Boolean(this.closest(".header-search-panel__default"));
        const linkClass = inHeaderPanel ? "header-search-panel__nav-link" : "search__nav-link";
        const itemClass = inHeaderPanel ? "header-search-panel__nav-item" : "search__nav-item";
        let items = [];

        const recentSearchesStoredString = localStorage.getItem("recentSearches");
        if (recentSearchesStoredString) {
            try {
                const recentSearchesStored = JSON.parse(recentSearchesStoredString);
                if (Array.isArray(recentSearchesStored)) {
                    items = recentSearchesStored.filter(
                        (item) => item && String(item.query || "").trim().length > 0
                    );
                }
            } catch (error) {
                items = [];
            }
        }

        if (items.length > 0) {
            parent?.classList.add("has-recent-searches");
            this.classList.add("has-items");
            this.classList.remove("is-empty");
            ul.innerHTML = items.reverse().reduce(
                (innerHTML, item) => `\n            ${innerHTML}\n            <li class="${itemClass}">\n              <a href="${item.uri}" class="${linkClass}">${item.query}</a>\n            </li>\n          `,
                ""
            );
            this.removeAttribute("hidden");
            this.style.removeProperty("display");
            return;
        }

        ul.innerHTML = "";
        this.setAttribute("hidden", "");
        this.classList.add("is-empty");
        this.classList.remove("has-items");
        this.style.setProperty("display", "none", "important");
        parent?.classList.remove("has-recent-searches");
    }
}

customElements.define("recent-searches", RecentSearches);
//# sourceMappingURL=recent-searches.js.map
